export default {

    pupUpIsVisible(state){
        return state.pop_ups.isVisible
    },

    bodyPopUps(state){
        return state.pop_ups
    },

    getDataIsVisible(state){
        return state.get_data.isVisible
    },

    visitantFormIsVisible(state){
        return state.visitant_form.isVisible
    }
}